import { tw } from "@careinfo/tailwind";
import SettingsIcon from "../../../Icons/SettingsIcon";

export default function Filter() {
  return (
    <button
      className={tw`bg-[#dcdcdc] px-6 rounded-md py-1 flex items-center gap-x-2 justify-center focus:outline-none`}
    >
      <span className={tw`block w-6 h-6`}>
        <SettingsIcon />
      </span>
      <span className={tw`block text-lg `}>Filter</span>
    </button>
  );
}
